import React, { useEffect, useState } from "react";
import helpIcon from "../../../../../assets/disabilityIcons/IC_Help.svg";
import CustomModal from "../../../../../components/styled-components/modal/custom-modal/custom-modal";
import MenuIcon from "../../../../../assets/disabilityIcons/Menu.svg";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import { Table } from "antd";
import { MODULE_API } from "../../../../../apis";
import { DisabilityFormCreator } from "../../../../../newComponents/V2Insurance/components/DisabilityFormCreator";
import "./style/insuranceCoverage.css";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { ToolTipCreator } from "../../../../../helpers/ToolTipCreator";

export default function InsuranceCoverage(props) {
  const [fields, setFields] = useState({});
  const [tabs, setTabs] = useState([]);
  const [fieldsData, setFieldsData] = useState({});
  const [loading, setLoading] = useState(false);
  const [submitBody, setSubmitBody] = useState({});
  const [moduleName, setModuleName] = useState("Insurance Coverage");
  const [toUpdate, setToUpdate] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [formData, setFormData] = useState({});
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [subModulefields, setSubModuleFields] = useState(null);
  const [paginatedModule, setPaginatedModule] = useState({
    insuranceProductsData: {
      currentPage: 1,
      totalPages: 1,
    },
  });
  const [tableData, setTableData] = useState({
    insuranceProductsData: [],
  });
  const history = useHistory();

  console.log(fields["Insurance Coverage"]);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleItemsInfoSelect = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handelCloseModal = () => {
    setIsModalVisible(false);
  };

  const getAttribute = async (moduleName) => {
    try {
      setLoading(true);
      const res = await MODULE_API.fetchAttributes(moduleName);
      if (res) {
        res.attributes &&
          res.attributes.map((attribute) => {
            setLoading(false);
            setFields((prevValue) => {
              return {
                ...prevValue,
                [attribute["groupName"]]: {
                  ...(prevValue[attribute["groupName"]] || {}),
                  [attribute["id"]]: attribute,
                },
              };
            });
          });
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching attributes", error);
    }
  };
  const fetchAllModulesData = async () => {
    setLoading(true);
    try {
      const results = await Promise.all(moduleNames.map((name) => fetchData(name)));
      console.log("All module results:", results);

      const insuranceCoverageModule = results.find((item) => item.moduleName === "Insurance Coverage");
      if (insuranceCoverageModule) {
        const targetRecord = insuranceCoverageModule.records.find(
          (record) => record.subType === "Disability" || "Self-Funding Amount" in record
        );
        setFieldsData(targetRecord);
      } else {
        console.log("surance Coverage module not found");
      }

      const tableDataObj = results.reduce((acc, { moduleName, records }) => {
        acc[formatModuleKey(moduleName)] = records;
        return acc;
      }, {});
      setTableData(tableDataObj);
    } catch (error) {
      console.error("Error fetching all modules:", error);
    } finally {
      setLoading(false);
    }
  };
  // Helper to format key names dynamically
  const formatModuleKey = (moduleName) => {
    return (
      moduleName &&
      moduleName
        .replace(/[^a-zA-Z ]/g, "") // Remove special chars
        .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) =>
          index === 0 ? word.toLowerCase() : word.toUpperCase()
        )
        .replace(/\s+/g, "") + "Data"
    );
  };
  const moduleNames = ["Insurance Products", "Insurance Coverage"];
  const fetchData = async (moduleName, page = 1) => {
    try {
      setLoading(true);
      const res = await MODULE_API.fetchItems({
        moduleName: moduleName,
        pageNum: 1,
        limit: 10,
        body: {},
      });
      const records = res.records || [];
      const pagenum = res.pagination && res.pagination.page;
      const total = res.pagination && res.pagination.total;
      setPaginatedModule((prev) => {
        return {
          ...prev,
          [formatModuleKey(moduleName)]: { currentPage: page, totalPages: Math.ceil(total / 10) },
        };
      });
      setLoading(false);
      return { moduleName, records, pagenum, total }; // Return object with moduleName to map later
    } catch (error) {
      console.error(`Error fetching data for ${moduleName}:`, error);
      return { moduleName, records: [] }; // Return empty if failed
    } finally {
      setLoading(false);
    }
  };
  console.log("formData", formData);
  const viewModal = async (record) => {
    if (!record) return;
    setFormData(record);
    setIsModalVisible(true);
    setModalTitle("View Item");
    await getSubModuleAttributes(record.module);
  };
  const getSubModuleAttributes = async (submod) => {
    try {
      setLoading(true);
      const res = await MODULE_API.fetchAttributes(submod);
      if (res && res.attributes) {
        setSubModuleFields(res);
      }
    } catch (error) {
      console.error("Error fetching attributes", error);
    }
  };
  const deleteRecord = async (record) => {
    try {
      setLoading(true);

      await MODULE_API.deleteItem({
        clientModules: [record.id],
      });

      const res = await fetchData(record.module);
      setTableData((prev) => ({
        ...prev,
        [formatModuleKey(record.module)]: res && res.records ? res.records : [],
      }));
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  const updateRecord = async () => {
    try {
      setLoading(true);
      await MODULE_API.updateClientModule(formData.id, {
        ...formData,
      });
      const res = await fetchData(formData.module);
      setTableData((prev) => ({
        ...prev,
        [formatModuleKey(formData.module)]: res && res.records ? res.records : [],
      }));
      setLoading(false);
      setFormData(null);
    } catch (error) {
    } finally {
      setLoading(false);
      setFormData(null);
    }
  };
  const createAttributes = async () => {
    try {
      setLoading(true);
      await MODULE_API.addAsset(moduleName, {
        clientModules: [formData],
      });
      const res = await fetchData(moduleName);
      setTableData((prev) => ({
        ...prev,
        [formatModuleKey(moduleName)]: res && res.records ? res.records : [],
      }));
      setLoading(false);
      setToUpdate(true);
    } catch (error) {
      console.log(error);
    } finally {
      setFormData(null);
    }
  };

  const getSelectedRow = (id) => {
    setSelectedIndex(id);
  };
  useEffect(() => {
    setModuleName("Insurance Coverage");
    getAttribute(props.activeStep.name);
    fetchAllModulesData();
  }, []);
  useEffect(() => {
    if (fieldsData && fieldsData.id) {
      setToUpdate(true);
    }
  }, [fieldsData]);

  useEffect(() => {
    setTabs(Object.keys(fields));
  }, [fields]);
  const columnsData = [
    {
      title: "Provider",
      dataIndex: "Provider",
      key: "provider",
      render: (val) => val || "N/A",
    },
    {
      title: "Policy Number",
      dataIndex: "Policy Number",
      key: "policyNumber",
      render: (val) => val || "N/A",
    },
    {
      title: "Short/Long Term",
      dataIndex: "Short/Long Term",
      key: "shortLongTerm",
      render: (val) => val || "N/A",
    },
    {
      title: "Type of Policy",
      dataIndex: "Type of Policy",
      key: "typeOfPolicy",
      render: (val) => val || "N/A",
    },
    {
      title: "Waiting Period",
      dataIndex: "Waiting Period",
      key: "waitingPeriod",
      render: (val) => val || "N/A",
    },
    {
      title: "Benefit Period",
      dataIndex: "Benefit Period",
      key: "benefitPeriod",
      render: (val) => val || "N/A",
    },
    {
      title: "Coverage Amount",
      dataIndex: "Coverage Amount",
      key: "coverageAmount",
      render: (val) => (val !== null && val !== undefined ? val : "N/A"),
    },
    {
      title: "Employer Contact",
      dataIndex: "Employer Contact",
      key: "employerContact",
      render: (val) => val || "N/A",
    },
    {
      title: "Employer Contact Phone",
      dataIndex: "Employer Contact Phone",
      key: "employerContactPhone",
      render: (val) => val || "N/A",
    },
    {
      title: "Action",
      key: "action",
      render: (record, index) => (
        <React.Fragment>
          <div style={{ display: "flex" }} key={index}>
            <div
              onClick={() => {
                getSelectedRow(record.id);
                setDropdown(!dropdown);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "6px 16px",
                width: "5px",
              }}
            >
              <img src={MenuIcon} style={{ rotate: "90deg" }} alt="menuIcon" />
            </div>

            {dropdown && selectedIndex === record.id && (
              <React.Fragment>
                <div
                  onClick={() => setDropdown(false)}
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}
                ></div>

                <div className="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    <li
                      className="liHover"
                      onClick={() => {
                        history.push(`/insurance_new/attributes/${record.module}/${record.id}/view`);
                      }}
                    >
                      View
                    </li>
                    <li
                      className="liHover"
                      onClick={() => {
                        history.push(`/insurance_new/attributes/${record.module}/${record.id}`);
                      }}
                    >
                      Update
                    </li>
                    <li
                      className="liHover"
                      onClick={() => {
                        deleteRecord(record);
                        setDropdown(false);
                      }}
                    >
                      Delete
                    </li>
                  </ul>
                </div>
              </React.Fragment>
            )}
          </div>
        </React.Fragment>
      ),
    },
  ];

  console.log("tabledataobj", tableData);
  return (
    <>
      <div className="insurance-coverage-container">
        <div className="insurance-coverage-title-container">
        <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
          <h2 className="insurance-coverage-title">Insurance Coverage</h2>
          <ToolTipCreator name={"Disability_Insurance_Coverage"}/>
        </div>
        </div>
        {/* <div className="insurance-coverage-help-icon-container">
          <img src={helpIcon} alt="help-icon" width="18.67px" height="18.67px" />
        </div> */}
      </div>

      <div class="dropdown-wrapper">
        <select class="dropdown-select" id="dropdown-select" name="options">
          <option value="" disabled selected>
            Insurance Policy to Apply
          </option>
          <option value="option1">Option 1</option>
          <option value="option2">Option 2</option>
          <option value="option3">Option 3</option>
          <option value="option4">Option 4</option>
        </select>
      </div>
      <div className="insurance-policies-container">
        <div className="insurance-policies-header-container">
          <div className="insurance-policies-title-container">
            <h2 className="insurance-policies-title">Insurance Policies</h2>
          </div>
        </div>
        <div className="insurance-policies-table-container">
          <Table
            columns={columnsData}
            dataSource={tableData.insuranceProductsData}
            pagination={{
              total: paginatedModule.insuranceProductsData.totalPages * 10, // Assuming 10 items per page
              current: paginatedModule.insuranceProductsData.currentPage,
              pageSize: 10,
              onChange: async (page) => {
                console.log("pageeeeeeeeeeee", page);
                const modulName = "Insurance Products";
                setPaginatedModule((prev) => ({
                  ...prev,
                  [formatModuleKey(modulName)]: {
                    ...prev.insuranceProductsData,
                    currentPage: page,
                  },
                }));
                const res = await fetchData(modulName, page);
                setTableData((prev) => ({
                  ...prev,
                  [formatModuleKey(modulName)]: res.records || [],
                }));
              },
            }}
          />
          <NewLoader isLoading={loading} />
        </div>
      </div>
      <div className="input-fields-container">
        {tabs.length > 0 && (
          <>
            <DisabilityFormCreator
              data={fields["Insurance Coverage"]}
              values={fieldsData}
              setSubmitBody={setFormData}
            />
          </>
        )}
        {/* <NewLoader isLoading={loading} /> */}
      </div>
      {!loading && fields && (
        <div className="handle-submit-button-container">
          <button
            className="submit-button"
            onClick={() => {
              if (toUpdate) {
                updateRecord();
              } else {
                createAttributes();
              }
            }}
          >
            {toUpdate ? "Update" : "Submit"}
          </button>
        </div>
      )}
    </>
  );
}
